import DocumentUpload from './DocumentUpload.vue';

export default DocumentUpload;
